export const fmt = (date) => new Date(date).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
export const fmtShort = (date) => new Date(date).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });

export function nightsBetween(start, end) {
  const diff = (new Date(end) - new Date(start)) / 86400000;
  return Math.max(1, Math.round(diff));
}

export function toInternational(value) {
  const raw = String(value || '').trim();
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (raw.startsWith('+')) return digits;
  if (digits.startsWith('00')) return digits.slice(2);
  if (digits.startsWith('0')) return `94${digits.slice(1)}`;
  return digits;
}

export function parseRequest(request = '') {
  const match = String(request).match(/\s*WhatsApp number:\s*(\+?[\d\s-]{6,})/i);
  const whatsapp = match ? match[1].trim() : '';
  const note = String(request).replace(/\s*WhatsApp number:\s*\+?[\d\s-]{6,}/i, '').trim();
  return { note, whatsapp };
}

export function contactLinks(booking) {
  const { note, whatsapp } = parseRequest(booking.request);
  const waDigits = toInternational(whatsapp || booking.phone);
  const greeting = `Hello ${booking.name}, thank you for your enquiry at K and son’s Guest House.`;
  return {
    note,
    whatsappNumber: whatsapp || booking.phone || '',
    whatsapp: waDigits ? `https://wa.me/${waDigits}?text=${encodeURIComponent(greeting)}` : '',
    call: booking.phone ? `tel:${booking.phone.replace(/[^\d+]/g, '')}` : '',
    email: booking.email ? `mailto:${booking.email}` : ''
  };
}